import React, { useState, useEffect } from "react";
import { Box, Text, Select, VStack, HStack, Icon, Flex, useColorMode } from "@chakra-ui/react";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import type { ChartData, ChartOptions } from "chart.js";
import { FaTasks, FaPlayCircle, FaCheckCircle } from "react-icons/fa";
import type { BarControllerDatasetOptions } from "chart.js";

// Register chart.js components
Chart.register(...registerables);

// Define the Task interface
interface Task {
  id: string;
  name: string;
  status: "Not-started" | "In-progress" | "completed" | "delay";
}

// Props for the TaskChart component
interface TaskViewProps {
  tasks: Task[];
  length: number;
}

const TaskView: React.FC<TaskViewProps> = ({ tasks, length }) => {
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  const { colorMode } = useColorMode();
  const isDark = colorMode === "dark";

  // Categorize tasks by status
  const taskStatusCount = {
    "Not-started": 0,
    "In-progress": 0,
    completed: 0,
    delay: 0, // This will track assigned tasks
  };

  // Count tasks by status and assigned status


  tasks.forEach((task) => {
    if (taskStatusCount[task.status] !== undefined) {
      taskStatusCount[task.status] += 1;
    }
  });

 
  // Prepare the data for the chart
  // ↓ tell TS this is bar‐chart data
  const chartData: ChartData<"bar", number[], string> = {
    // 3️⃣ update your labels and data order
    labels: ["Delayed", "Not started", "In Progress", "Completed"],
    datasets: [
      {
        label: "Task Count",
        data: [
          taskStatusCount["delay"],
          taskStatusCount["Not-started"],
          taskStatusCount["In-progress"],
          taskStatusCount["completed"],
        ],

        /* ← these belong on the dataset now: */
        categoryPercentage: 1,
        barPercentage: 1,
        maxBarThickness: 40,

        backgroundColor: ["#F87171", "#FFE066", "#A0C4FF", "#B2F2BB"],

        borderWidth: 1,
      },
    ],
  };

  // ↓ tell TS these are the bar‐chart options
  const chartOptions: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: 0 },

    scales: {
      x: {
        type: "category",
        offset: true,
        grid: { display: false },
        ticks: {
          color: isDark ? "#E2E8F0" : "#2D3748",
        },
      },
      y: {
        beginAtZero: true,
        ticks: { 
          stepSize: 1,
          color: isDark ? "#E2E8F0" : "#2D3748",
        },
        grid: {
          color: isDark ? "#4A5568" : "#E2E8F0",
        },
        border: {
          color: isDark ? "#4A5568" : "#E2E8F0",
        },
      },
    },

    plugins: {
      tooltip: {
        enabled: true,
        callbacks: {
          label: ({ label, raw }) => `${label}: ${raw} Tasks`,
        },
      },
      legend: { display: false },
    },
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedStatus(e.target.value);
  };

  return (
  <Box
    p={5}
    borderRadius="md"
    display="flex"
    width="100%"
    flexDirection="column" // stack chart + labels
  >
    {/* 1) Chart container */}
    <Box flex="1" position="relative" width="100%" height="300px">
      <Bar data={chartData} options={chartOptions} />
    </Box>


    
  </Box>
);

};

export default TaskView;
